import api from "./index";

export async function getSettings() {
  return api.get(`/settings`);
}

export async function saveSettings(formData) {
  return api.put(`/settings`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export async function saveTermsAndConditions(formData) {
  return api.post(`/settings/terms-and-conditions`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
